module.exports = __webpack_public_path__ + "img/img-header-2.bfa48ea9.png";